// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__fwjjI","ScrollX":"Scroll_ScrollX__2mrMw","ScrollY":"Scroll_ScrollY__E9WlH"};